const getIncidentCategory = ({incident}: any) => {
  let incidentCategory

  switch (incident.incidentType) {
    case "Verbal_Abuse":
      incidentCategory = incident.verbalAbuseInitiatingFactor.replace('_', ' ') ?? null
      break;
    case "Antisocial_Behaviour":
      incidentCategory = incident.antisocialBehaviourType.replace('_', ' ') ?? null
      break;
    default:
      incidentCategory = null
      break;
  }
  return incidentCategory
}

export default getIncidentCategory